import React from 'react';
import { Share2, Send, MessageCircle, Twitter, Facebook, Link2 } from 'lucide-react';
import { toast } from 'sonner';

export function ShareButtons({ url, text, testIdPrefix = 'share' }: { url: string; text: string; testIdPrefix?: string }) {
  const enc = encodeURIComponent(url);
  const encText = encodeURIComponent(text);
  const open = (u: string) => window.open(u, '_blank', 'noopener,noreferrer');

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link disalin', { description: 'Link signal siap dibagikan.' });
    } catch {
      toast.error('Gagal menyalin link');
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: 'Signal Cuantrader', text, url }); } catch { /* cancelled */ }
    } else {
      copy();
    }
  };

  const btn = 'flex items-center gap-1.5 text-xs px-3 py-2 rounded-lg border transition-colors';
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testIdPrefix}-buttons`}>
      <button data-testid={`${testIdPrefix}-whatsapp`} onClick={() => open(`https://wa.me/?text=${encText}%20${enc}`)} className={`${btn} border-emerald-400/30 text-emerald-300 hover:bg-emerald-400/10`}><MessageCircle className="w-4 h-4" strokeWidth={1.5} /> WhatsApp</button>
      <button data-testid={`${testIdPrefix}-telegram`} onClick={() => open(`https://t.me/share/url?url=${enc}&text=${encText}`)} className={`${btn} border-sky-400/30 text-sky-300 hover:bg-sky-400/10`}><Send className="w-4 h-4" strokeWidth={1.5} /> Telegram</button>
      <button data-testid={`${testIdPrefix}-twitter`} onClick={() => open(`https://twitter.com/intent/tweet?text=${encText}&url=${enc}`)} className={`${btn} border-white/20 text-white/80 hover:bg-white/10`}><Twitter className="w-4 h-4" strokeWidth={1.5} /> X</button>
      <button data-testid={`${testIdPrefix}-facebook`} onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${enc}`)} className={`${btn} border-blue-400/30 text-blue-300 hover:bg-blue-400/10`}><Facebook className="w-4 h-4" strokeWidth={1.5} /> Facebook</button>
      <button data-testid={`${testIdPrefix}-copy`} onClick={copy} className={`${btn} border-cyan-400/30 text-cyan-300 hover:bg-cyan-400/10`}><Link2 className="w-4 h-4" strokeWidth={1.5} /> Copy Link</button>
      <button data-testid={`${testIdPrefix}-native`} onClick={nativeShare} className={`${btn} border-white/20 text-white/80 hover:bg-white/10`}><Share2 className="w-4 h-4" strokeWidth={1.5} /> Bagikan</button>
    </div>
  );
}
